var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToogleMenuRecolhido(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 25.118,
    viewBox: "0 0 28 18.118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15L17.5 15V13.3333L2.5 13.3333V15ZM2.5 10.8333H17.5V9.16667H2.5V10.8333ZM2.5 5V6.66667L17.5 6.66667V5L2.5 5Z",
    fill: "#33CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToogleMenuRecolhido);
export default __webpack_public_path__ + "static/media/toogle_menu_recolhido.5441cd446d5295deccb8abaee2ba6165.svg";
export { ForwardRef as ReactComponent };